export default __webpack_public_path__ + "static/media/spoleto.0b8df33a.png";